import { scroller } from "./scroll";
export function cartDrawer(element: HTMLElement): void {
  // Drawer has duplicated so now multiple links
  Array.prototype.slice.apply(
    document.getElementsByClassName('js-cart-open')
  ).forEach((open) => {
    open.addEventListener('click', (e: any) => {
      e.preventDefault();
      element.classList.add('--open');
      document.documentElement.classList.add('cart--open');
      scroller.stop();
    });
  })
  Array.prototype.slice.apply(
    document.getElementsByClassName('js-cart-close')
  ).forEach((close) => {
    close.addEventListener('click', (e: any) => {
      e.preventDefault();
      element.classList.remove('--open');
      document.documentElement.classList.remove('cart--open');
      scroller.start();
    });
  })

}